module.exports = __webpack_public_path__ + "static/img/ecode.88817776.jpg";